import { styled } from '@clickcease/cc-client-components-lib'

export const CheckoutPlanDetailsStyles = styled('div', {
  border: '1px solid $lightNeutral',
  width: '316px',
  minHeight: '142px',
  borderRadius: '4px',
  padding: '$8',
  marginLeft: '$20',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',

  '@bp1': {
    marginLeft: '0px',
    width: '90%',
  },
})

export const CheckoutPlanDetailsTopRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})

export const CheckoutPlanDetailsEditPlan = styled('div', {
  color: '$CHEQPrimary',
  fontSize: '$md',
  fontWeight: '$sb',
  textDecoration: 'underline',
  cursor: 'pointer',
})

export const CheckoutPlanDetailsTitle = styled('div', {
  fontWeight: '$sb',
  fontSize: '$h5',
})

export const CheckoutPlanDetailsRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: '$8',
})

export const CheckoutPlanBundleRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: '$8',
})

export const CheckoutPlanBundleDescription = styled('div', {
  fontSize: '$md',
  color: '$success',
  background: '$lightGreen',
  padding: '6px',
})

export const CheckoutPlanDescription = styled('div', { fontSize: '$lg' })
export const CheckoutPlanVisitsAmount = styled('div', { fontSize: '$sm' })

export const CheckoutPlanPrice = styled('div', {
  fontSize: '$lg',
})

export const CheckoutPlanBundlePrice = styled('div', { color: '$success', lineHeight: '30px' })

export const CheckoutPlanSeparator = styled('div', {
  width: '100%',
  height: '1px',
  background: '$lightNeutral',
  margin: '25px 0px 10px 0px',
})
export const CheckoutPlanUpperSeparator = styled('div', {
  width: '100%',
  height: '1px',
  background: '$lightNeutral',
  margin: '25px 0px 10px 0px',
})

export const CheckoutPlanBottomRow = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: '$8',
})

export const CheckoutPlanMonthlyWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '$5',
})

export const CheckoutPlanMonthlyTitle = styled('div', { fontSize: '$lg' })

export const PaymentPlanTitle = styled('div', {
  fontSize: '$lg',
})

export const CheckoutPlanMonthlyAmount = styled('span', {
  fontSize: '$lg',
})

export const CheckoutPlanTotalWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})

export const CheckoutPlanTotalTitle = styled('div', {
  fontSize: '$lg',
  fontWeight: '$sb',
  display: 'flex',
})

export const CheckoutPlanAmountPerMonth = styled('span', {
  fontWeight: '$r',
  marginRight: '3px',
})

export const CheckoutPlanTotalPrice = styled('span', {
  fontWeight: '$r',
  marginRight: '3px',
  color: '$darkNeutral',
  fontSize: '$sm',
})

export const CheckoutPlanTotalAmount = styled('span', {
  fontWeight: '$sb',
  fontSize: '$lg',
})
export const CheckoutFirstPayment = styled('div', {
  fontWeight: '$l',
  fontSize: '$sm',
  width: '100%',
  marginTop: '$5',
  marginBottom: '$4',
})

export const CheckoutOverageDisclaimer = styled('div', {
  fontWeight: '$l',
  fontSize: '$xs',
  width: '100%',
  marginTop: '$5',
})

export const CheckoutCouponRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  marginTop: '$8',
})

export const CheckoutCouponDescription = styled('div', {
  fontSize: '$md',
  color: '$success',
  background: '$lightGreen',
  padding: '6px',
})

export const CheckoutCouponPrice = styled('div', { color: '$success', lineHeight: '30px' })

export const ToasterWrapper = styled('div', {
  marginTop: '$8',
})
